// @ts-strict-ignore
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import { getPollSeo } from 'src/utils/seo';

import { CommunityLayout } from 'src/components/layouts';
import SinglePostSidebar from 'src/modules/community/shared/components/sidebar/singlePostSidebar';
import Poll from 'src/modules/community/poll/poll';
import Responses from 'src/modules/community/singlePost/components/responses';
import { Poll as PollType } from 'src/constants/types';
import WriteReplyBox from 'src/modules/community/singlePost/components/replies/writeReplyBox';

export default function PollPage(): JSX.Element {
  const poll = useSelector(({ pages }) => pages.singlePost.post as PollType);
  const { currentUser, currentCommunity } = useSelector(({ context }) => context);
  if (!poll) return null;

  return (
    <CommunityLayout
      currentPage="poll"
      seo={getPollSeo(poll, currentCommunity)}
      sideBarContent={<SinglePostSidebar />}
    >
      <Content>

        <Poll />

        {!!currentUser && !poll.isLocked && (
          <div className="post-respond">
            <WriteReplyBox />
          </div>
        )}

        <Responses />
      </Content>
    </CommunityLayout>
  );
}

const Content = styled.div`
  @media (${props => props.theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;
